export default "__VITE_ASSET__CL0HAzl7__"